import * as types from '../types'
import moment from 'moment'
import update from 'immutability-helper'

export const initialSearchFilter = {
    CompID: '',
    CoAID: '',
    ModuleID: '',
    ModuleName: 0,
    approverOneID: '',
    approverOneName: '',
    approverTwoID: '',
    approverTwoName: '',
    approverThreeID: '',
    approverThreeName: '',
    Pagination: {
        Page: 0,
        PageSize: 10,
    },
    Sort: {
        field: 'CoAID',
        sort: 'desc'
    },
}

const defaultState = {
    reducerVariable: 'Configuration of Approvers',
    searchLabel: 'Configuration of Approvers Search',
    searchFilter: {
        ...initialSearchFilter
    },
    updateValues: {
        ...initialSearchFilter
    },
    resultTable: {
        // Applied Filter from search from
        appliedFilter: {
            ...initialSearchFilter
        },
        // Table Data
        loading: true,
        data: [],
        totalCount: 0,
        selectedRows: [],
    },
    alert: {
        show: false,
        title: 'Update success',
        content: 'Successfuly updated record.',
        confirmLabel: 'Ok',
        onHide: () => { },
    },
    confirmModal: {
        show: false,
        title: 'Confirm Deletion',
        message: 'Do you want to delete this record?',
        confirmData: null, // Set the data to be passed in confirm
        onConfirm: () => { },
        onClose: () => { },
    },
    approverddl: [],
}

// Define how the states will change based on the dispatched action

export default function listReducer(state = defaultState, action) {
    switch (action.type) {
        case types.APPLY_FILTERS:
            return update(state, {
                resultTable: {
                    appliedFilter: { $set: action.payload },
                    selectedRows: { $set: [] },
                }
            })
        case types.CHANGE_UPDATE_VALUES:
            return update(state, {
                updateValues: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            })
        case types.FETCH_APPROVER_VALUES:
            return update(state, {
                updateValues: {
                    $set: action.payload.data
                }
            })
        case types.RESET_FILTERS:
            return update(state, {
                searchFilter: {
                    $set: initialSearchFilter
                },
                resultTable: {
                    appliedFilter: { $set: initialSearchFilter },
                    selectedRows: { $set: [] },
                }
            })
        case types.RESET_RESULTS:
            return update(state, {
                searchFilter: {
                    $set: initialSearchFilter
                },
                resultTable: {
                    appliedFilter: { $set: initialSearchFilter },
                    data: { $set: [] },
                    totalCount: { $set: 0 },
                    selectedRows: { $set: [] },
                }
            })
        case types.UPDATE_SEARCHLIST:
            return update(state, {
                resultTable: {
                    data: { $set: action.payload.data },
                    totalCount: { $set: action.payload.totalCount },
                    selectedRows: { $set: [] },
                }
            })
        case types.IS_LOADING:
            return update(state, {
                resultTable: {
                    loading: { $set: action.payload }
                }
            })

        // SEARCH FILTER FIELDS
        case types.SET_CONFIRM_MODAL:
            return update(state, {
                confirmModal: { $set: action.payload }
            })

        case types.HIDE_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: false }
                }
            })
        case types.SHOW_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: true }
                }
            })
        case types.HIDE_LIST_ALERT:
            return update(state, {
                alert: {
                    show: { $set: false }
                }
            });
        case types.SET_LIST_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.FETCH_EMPLOYEE_SV_DDL:
            return update (state, {
                approverddl: { $set: action.payload }
            })
        case types.CHG_FILTER_DATA:
            return update(state, {
                searchFilter: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            })
        default: return state
    }
}
